import { type NavigationGuard } from 'vue-router';
import { DATA_IMPORT_FLAG } from '@/data-import/constants';
import { isRolloutFlagEnabled } from '@/plugins/rollout-flags';
import { useAuthStore } from '@/stores/auth';
import { useCompanyStore } from '@/stores/company';

export const redirectToHomeIfNoAccess: NavigationGuard = async (to, from, next) => {
  const { appAccess } = useAuthStore();

  if (!appAccess.nav.people) {
    return next({ name: 'home' });
  }
  return next();
};

export const redirectToHomeIfNoSettingsAccess: NavigationGuard = async (to, from, next) => {
  const { appAccess } = useAuthStore();

  if (!appAccess.people.settings) {
    return next({ name: 'people-list' });
  }

  if (to.name === 'people-employee-portal-settings' && !appAccess.people.show_employee_portal_settings) {
    return next({ name: 'people-access-settings' });
  }

  if (to.name === 'people-settings-columns' && (!appAccess.nav.data || isRolloutFlagEnabled(DATA_IMPORT_FLAG))) {
    return next({ name: 'people-settings' });
  }

  if (to.name === 'people-manager-permissions-settings' && !appAccess.people.show_managers_settings) {
    return next({ name: 'people-settings' });
  }

  return next();
};

export const redirectToListIfNoSummaryAccess: NavigationGuard = async (to, from, next) => {
  const { appAccess } = useAuthStore();

  if (!appAccess.people.summary.view) {
    return next({ name: 'people-list' });
  }
  return next();
};

export const redirectToHomeIfNoMyPortalAccess: NavigationGuard = async (to, from, next) => {
  const authStore = useAuthStore();
  const companyStore = useCompanyStore();

  if (
    companyStore.usingEmployeePortal &&
    authStore.profile.employee_v2_id &&
    (authStore.isUserAdmin || companyStore.nonAdminAccessToEmployeePortal)
  ) {
    return next();
  } else {
    return next({ name: 'home' });
  }
};
